import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lean-composit',
  templateUrl: './lean-composit.component.html',
  styleUrls: ['./lean-composit.component.scss']
})

export class LeanCompositComponent implements OnInit {


  @Input() title          : string = "Kpi"; 
  @Input() color          : string = "darkorange"

  @Input() width          : string = '200';
  @Input() minWidth       : string = '200';
 

  constructor() {
  }


  ngOnInit() {

  }



}
